export const initialQuizWrapperState = {
  id: null,
  name: null,
  organization_id: null,
  type: null,
  config: {},
};

export const quizWrapperReducer = (state = initialQuizWrapperState, action) => {
  switch (action.type) {
    case "SET_QUIZ_WRAPPER":
      return { ...state, ...action.payload };

    default:
      return state;
  }
};
